import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";

import CircularProgress from "@mui/material/CircularProgress";

import { useAppDispatch } from "store/hooks";
import { createDynamicIbanQr } from "store/features/publicIbanQrSlice";

import AuthLayout from "layouts/AuthLayout";
import ErrorPage from "../../components/ErrorPage";

import { ApiError } from "types";

const DynamicInvoice: React.FC = () => {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { uid } = useParams<{ uid: string }>();
  const { search } = useLocation();

  const queryParams = new URLSearchParams(search);
  const price = queryParams.get("price") || undefined;
  const invoiceNumber = queryParams.get("number") || undefined;

  useEffect(() => {
    setLoading(true);
    if (uid) {
      dispatch(createDynamicIbanQr({ uid, price, invoiceNumber }))
        .unwrap()
        .then((data) => {
          const { url } = data;
          if (url) {
            window.location.replace(url);
          } else {
            setShowError(true);
          }
        })
        .catch((error: ApiError) => {
          setShowError(true);
          error?.data?.title && setErrorMessage(error.data.title);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
      setShowError(true);
    }
  }, []);

  if (showError) {
    return <ErrorPage message={errorMessage} />;
  }

  if (loading) {
    return (
      <AuthLayout>
        <CircularProgress />
      </AuthLayout>
    );
  }

  return null;
};

export default DynamicInvoice;
